(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["country-localization-geo-popup"] && !Shopify.designMode) return;
  try {
    (function () {
      const DATA_KEY             = 'fuse_geo_data_v2';
      const SHOWN_KEY            = 'fuse_geo_shown';
      const CONFIDENCE_THRESHOLD = 0.75;

      const shopify          = window.Shopify || {};
      const routes           = shopify.routes || {};
      const ROOT             = routes.root || '/';
      const CURRENT_LANG     = shopify.language || '';
      const CURRENT_COUNTRY  = shopify.country || '';

      function fetchGeoSuggestion() {
        const cached = sessionStorage.getItem(DATA_KEY);
        if (cached !== null) return Promise.resolve(JSON.parse(cached));

        let qs = 'country[enabled]=true&language[enabled]=true';
        if (CURRENT_LANG) qs += '&language[exclude]=' + encodeURIComponent(CURRENT_LANG);

        return fetch(ROOT + 'browsing_context_suggestions.json?' + qs)
          .then(function (res) {
            if (!res.ok) { sessionStorage.setItem(DATA_KEY, 'null'); return null; }
            return res.json().then(function (data) {
              sessionStorage.setItem(DATA_KEY, JSON.stringify(data));
              return data;
            });
          })
          .catch(function () { return null; });
      }

      function fetchLocaleStrings(langHandle) {
        return fetch('/' + langHandle + '/?sections=geo-popup-strings')
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (sections) {
            if (!sections || !sections['geo-popup-strings']) return null;
            const parser = new DOMParser();
            const doc    = parser.parseFromString(sections['geo-popup-strings'], 'text/html');
            const el     = doc.getElementById('geo-popup-strings-data');
            if (!el) return null;
            return {
              heading:    el.dataset.heading    || null,
              subheading: el.dataset.subheading || null,
              cta:        el.dataset.cta        || null
            };
          })
          .catch(function () { return null; });
      }

      function resolveStrings(overrides, langHandle, interpolate) {
        const allProvided = overrides.heading && overrides.subheading && overrides.cta;

        if (allProvided || !langHandle || langHandle === CURRENT_LANG) {
          return Promise.resolve({
            heading:    interpolate(overrides.heading),
            subheading: interpolate(overrides.subheading),
            cta:        interpolate(overrides.cta)
          });
        }

        return fetchLocaleStrings(langHandle).then(function (locale) {
          return {
            heading:    interpolate(overrides.heading    || (locale && locale.heading)),
            subheading: interpolate(overrides.subheading || (locale && locale.subheading)),
            cta:        interpolate(overrides.cta        || (locale && locale.cta))
          };
        });
      }

      function openPopupPanel(triggerBtn, panel, overlay) {
        triggerBtn.setAttribute('aria-expanded', 'true');
        panel.removeAttribute('hidden');
        if (overlay) overlay.removeAttribute('hidden');
        document.body.classList.add('overflow-hidden', 'no-scroll');
      }

      function swapText(panel, heading, subheading, cta, selectNote) {
        const els = {
          '.country-popup__heading':     heading,
          '.country-popup__subheading':  subheading,
          '.country-popup__cta':         cta,
          '.country-popup__select-note': selectNote
        };
        Object.keys(els).forEach(function (sel) {
          const val = els[sel];
          if (!val) return;
          const el = panel.querySelector(sel);
          if (!el) return;
          el.dataset.originalText = el.textContent;
          el.textContent = val;
        });

        new MutationObserver(function (mutations, observer) {
          if (!panel.hasAttribute('hidden')) return;
          observer.disconnect();
          ['.country-popup__heading', '.country-popup__subheading', '.country-popup__cta', '.country-popup__select-note'].forEach(function (sel) {
            const el = panel.querySelector(sel);
            if (el && el.dataset.originalText !== undefined) {
              el.textContent = el.dataset.originalText;
              delete el.dataset.originalText;
            }
          });
        }).observe(panel, { attributes: true, attributeFilter: ['hidden'] });
      }

      function applyGeoSuggestion(data) {
        if (!data) return;

        const detectedHandle = data.detected_values &&
                            data.detected_values.country &&
                            data.detected_values.country.handle;

        const suggestion         = data.suggestions && data.suggestions[0];
        const countryPart        = suggestion && suggestion.parts && suggestion.parts.country;
        const languagePart       = suggestion && suggestion.parts && suggestion.parts.language;
        const suggestedHandle      = (countryPart && countryPart.handle) || null;
        const suggestedConfidence  = (countryPart && countryPart.confidence) || 0;
        const suggestedLang        = (languagePart && languagePart.handle) ||
                                  (navigator.language || '').split('-')[0].toLowerCase() ||
                                  null;

        const detectedMismatch = detectedHandle && detectedHandle !== CURRENT_COUNTRY;
        if (!detectedMismatch) return;
        if (sessionStorage.getItem(SHOWN_KEY)) return;

        const countryName  = (countryPart && countryPart.name) ||
                          (data.detected_values && data.detected_values.country && data.detected_values.country.name) || '';
        const languageName = (languagePart && languagePart.name) || '';

        function interpolate(str) {
          if (!str) return str;
          return str.replace(/\[country\]/gi, countryName).replace(/\[language\]/gi, languageName);
        }

        const config    = document.querySelector('[data-geo-popup-config]');
        const overrides = {
          heading:    (config && config.dataset.geoHeading)      || null,
          subheading: (config && config.dataset.geoSubheading)   || null,
          cta:        (config && config.dataset.geoCta)          || null,
          selectNote: (config && config.dataset.geoSelectNote)   || null
        };

        resolveStrings(overrides, suggestedLang, interpolate).then(function (strings) {
          const popupEl = document.querySelector('[data-country-selector="popup"]');
          if (!popupEl) return;

          const triggerBtn = popupEl.querySelector('.country-popup__trigger');
          if (!triggerBtn) return;

          const panelId = triggerBtn.getAttribute('aria-controls');
          let panel   = panelId ? document.getElementById(panelId) : null;
          if (!panel) panel = document.body.querySelector('.country-popup__panel');
          if (!panel) return;

          const overlay = document.body.querySelector('.country-popup__overlay');
          const formEl  = popupEl.closest('localization-form');

          if (suggestedHandle && suggestedConfidence >= CONFIDENCE_THRESHOLD) {
              const link = panel.querySelector('.disclosure__link[data-value="' + CSS.escape(suggestedHandle) + '"]');
              if (link) {
                panel.querySelectorAll('.disclosure__item').forEach(function (item) {
                  item.classList.remove('is-suggested');
                });
                const disclosureItem = link.closest('.disclosure__item');
                if (disclosureItem) disclosureItem.classList.add('is-suggested');
                if (formEl) {
                  formEl._pendingIso = suggestedHandle;
                  if (typeof formEl._updatePopupSummary === 'function') {
                    formEl._updatePopupSummary(link);
                  }
                }
              }
            }

            // Pre-select suggested language in the language disclosure
            if (suggestedLang && formEl) {
                // First try the market_language_defaults mapping for this country
                if (suggestedHandle && typeof formEl._applyLanguageDefault === 'function') {
                  formEl._applyLanguageDefault(suggestedHandle);
                }
                // If no default was applied, try the detected language directly
                if (formEl._pendingLanguageIso === (formEl.elements && formEl.elements.languageInput && formEl.elements.languageInput.value)) {
                  const langLink = panel.querySelector('.country-popup__language-disclosure .disclosure__link[data-value="' + CSS.escape(suggestedLang) + '"]');
                  if (langLink) {
                    formEl._pendingLanguageIso = suggestedLang;
                    panel.querySelectorAll('.country-popup__language-disclosure .disclosure__item')
                      .forEach(function (item) { item.classList.remove('is-current'); });
                    const langItem = langLink.closest('.disclosure__item');
                    if (langItem) langItem.classList.add('is-current');
                    if (typeof formEl._updateLanguageSummary === 'function') {
                      formEl._updateLanguageSummary(langLink);
                    }
                  }
                }
            }

            swapText(panel, strings.heading, strings.subheading, strings.cta, overrides.selectNote);

            sessionStorage.setItem(SHOWN_KEY, '1');

            if (formEl && typeof formEl.openSelector === 'function') {
              formEl.openSelector();
            } else {
              openPopupPanel(triggerBtn, panel, overlay);
            }
        });
      }

      function init() {
        fetchGeoSuggestion().then(function (data) {
          if (data) setTimeout(function () {
            customElements.whenDefined('localization-form').then(function () {
              applyGeoSuggestion(data);
            });
          }, 800);
        });
      }

      if (document.readyState === 'complete') {
        init();
      } else {
        window.addEventListener('load', init);
      }
    })();
  } catch(e) { console.error(e); }
})();

})();
